import { render, staticRenderFns } from "./co-area.vue?vue&type=template&id=62d680c9&scoped=true&"
import script from "./co-area.vue?vue&type=script&lang=js&"
export * from "./co-area.vue?vue&type=script&lang=js&"
import style0 from "./co-area.vue?vue&type=style&index=0&id=62d680c9&prod&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62d680c9",
  null
  
)

export default component.exports